export default "__VITE_PUBLIC_ASSET__4c8d8d9c__"